import TripView from './TripView';

export default TripView;